export default "__VITE_ASSET__C6k2Cdgy__"